import {combineReducers} from "redux";
import layoutInteractionReducer from "./layout/interaction/Layout";
import tabReducer from "./tab/reducer";
import loginReducer from "./login/login";
import axiosReducer from "./axios/reducer";
import actionHistoryReducer from "./action-history/reducer";
import permissionAccountActionReducer from "./permission/permission";

const rootReducer = combineReducers({
    layoutInteractionReducer,
    tabReducer,
    loginReducer,
    axiosReducer,
    actionHistoryReducer,
    permissionAccountActionReducer
});

export default rootReducer;
